import React, { useState } from "react"
import { useSelector } from "react-redux"

import { getCheckoutPaymentInfo } from "utils"
import KcHeader from "./KcHeader"
import KcSummery from "./KcSummery"
import KcOrderContents from "./KcOrderContents"
import classes from "./index.module.scss"
import KcFooter from "./KcFooter"
import KcPaymentMethods from "./KcPaymentMethods"

const KioskCheckout = () => {
  const order =
    useSelector(state => state.order)

  const deliveryType =
    useSelector(state => state.deliveryInfo.deliveryType)

  const [paymentType, setPaymentType] = useState("pcPos")

  const discounts = []

  const deliveryFees = null

  const {
    total,
    subtotal,
    taxesAndCharges
  } = getCheckoutPaymentInfo(
    order.items,
    order.combos,
    discounts,
    deliveryFees,
    deliveryType
  )

  return (
    <div className={classes["container"]}>
      <KcHeader />

      <KcOrderContents />

      <div className={classes["footer"]}>
        <KcSummery
          total={total}
          subtotal={subtotal}
          taxesAndCharges={taxesAndCharges}
        />

        <KcPaymentMethods
          paymentType={paymentType}
          setPaymentType={setPaymentType}
        />

        <KcFooter
          paymentType={paymentType}
        />
      </div>
    </div>
  )
}

export default KioskCheckout